import { getElementFromEvent } from '../utils';

export const hashes = [];

document.addEventListener('click', (event) => {
	const link = getElementFromEvent(event, 'a');

	if (link && link.href.includes('#')) {
		if (window.location.pathname !== link.pathname) {
			// In the global afterEnter hook this hash will be used to scroll to the correct section
			const url = new URL(link.href);
			hashes.push(url.hash);
		}
	}
});
